import { useTranslation } from "react-i18next";
import { useLogout } from "../../../../hooks/auth";
import AccountPrivacyIcon from "./icons/AccountPrivacyIcon";
import LogoutIcon from "./icons/LogoutIcon";
import YourCompletedOrdersIcon from "./icons/YourCompletedOrdersIcon";
import YourProfileIcon from "./icons/YourProfileIcon";

function AccountInformation() {
  const { logout } = useLogout();
  const { t } = useTranslation();

  function handleLogout(e) {
    e.preventDefault();
    logout();
  }

  return (
    <div className="mt-9 font-custom">
      {/* Your Information */}
      <div>
        {/* <div className="w-40 justify-center text-stone-500 text-sm font-medium font-['HK_Grotesk'] leading-none">Your Information</div> */}
        <div className="text-stone-500 text-sm font-medium leading-none">
          {t("your_information")}
        </div>
        <div className="flex flex-col gap-4 mt-4">
          <a href="/profile" className="flex gap-[10px]">
            <YourProfileIcon />
            {t("your_profile")}
          </a>
          <a href="/order-track-list?tab=COMPLETED" className="flex gap-[10px]">
            <YourCompletedOrdersIcon />
            {t("your_completed_orders")}
          </a>
        </div>
      </div>

      {/* Other Information */}
      <div className="mt-5">
        <div className="text-stone-500 text-sm font-medium leading-none">
          {t("other_information")}
        </div>
        <div className="flex flex-col gap-4 mt-4">
          {/* To be added later because href not available! */}
          {/* <a href="#" className="flex gap-[10px]">
            <AccountPrivacyIcon />
            Account Privacy
          </a> */}
          {/* MARK::- HANDLE LOGOUT WebApp/PaytmApp */}
          <a href="#" onClick={handleLogout} className="flex gap-[10px]">
            <LogoutIcon />
            {t("logout")}
          </a>
        </div>
      </div>
    </div>
  );
}

export default AccountInformation;
